import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  mainContent: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'inherit',
    padding: 20
  },
  inputWrapper: {
    display: 'flex',
    maxWidth: 700,
    gridGap: 50,
    padding: '35px 0',
    flexWrap: 'nowrap'
  },
  mobleInputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexWrap: 'nowrap'
  },
  textField: {
    maxWidth: '350px',
    '& input': {
      padding: '16.5px 14px'
    },
    backgroundColor: '#fff'
  },
  mobileTextField: {
    maxWidth: '100%',
    '& input': {
      padding: '16.5px 14px'
    },
    backgroundColor: '#fff'
  },
  continueButton: {
    padding: '15px 40px',
    marginBlock: 20
  },
  scheduleWrapper: {
    border: 'none',
    borderRadius: 0,
    backgroundColor: 'transparent',
    padding: 0,
    width: '100%',
    maxWidth: 700,
    marginLeft: 0,
    marginRight: 0,
    boxSizing: 'border-box',
    alignSelf: 'stretch'
  },
  scheduleHeader: {
    marginBottom: 20
  },
  scheduleTitle: {
    marginBottom: 6
  },
  scheduleGrid: {
    width: '100%'
  },
  scheduleSectionTitle: {
    marginBottom: 12
  },
  hoursBlock: {
    paddingTop: 6,
    paddingBottom: 18,
    minWidth: '100%',
    '&:not(:last-child)': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
    }
  }
}));
